import { getTranslationID } from "translation";

export const LANGUAGE_LIST = [
  {
    value: "de-DE",
    label: getTranslationID("loginPage.label.displayLanguageGerman"),
  },
  {
    value: "en",
    label: getTranslationID("loginPage.label.displayLanguageEnglish"),
  },
  {
    value: "es-ES",
    label: getTranslationID("loginPage.label.displayLanguageSpanish"),
  },
  {
    value: "fr-FR",
    label: getTranslationID("loginPage.label.displayLanguageFrench"),
  },
  {
    value: "it-IT",
    label: getTranslationID("loginPage.label.displayLanguageItalian"),
  },
  {
    value: "ja",
    label: getTranslationID("loginPage.label.displayLanguageJapanese"),
  },
  {
    value: "ko-KR",
    label: getTranslationID("loginPage.label.displayLanguageKorean"),
  },
  {
    value: "zh-CN",
    label: getTranslationID("loginPage.label.displayLanguageSimplifiedChinese"),
  },
  {
    value: "zh-TW",
    label: getTranslationID(
      "loginPage.label.displayLanguageTraditionalChinese"
    ),
  },
];
